import React from 'react'

import {Box, Typography} from "@mui/material"


export default function createdColumn() {

    return {
        name: 'timestampCreate',
        label: 'Creation Date',
        options: {
            customBodyRowRenderLite: value => <Box
                sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Typography variant="body1">{value}</Typography>
            </Box>
        }
    }
}